<template>
  <div class="cm-field">
    <slot></slot>
  </div>
</template>

<script>
  import $ from 'jquery'
  import 'javascripts/select2'

  export default {
    mounted() {
      const selectTag = this.$el.querySelector('input')

      $(selectTag).select2({
        ajax: {
          url: '/individuals/user_autocomplete',
          dataType: 'json',
          data: (term, page, context) => {
            return {
              q: term
            }
          },
          results: function (data) {
            return {
              results: data.map(user => {
                return {
                  id: user['id'],
                  text: user['username']
                }
              })
            }
          }
        },
        closeOnSelect: false
      })
    }
  }
</script>



// WEBPACK FOOTER //
// app/javascript/components/collaborator-field.vue?85fe65de